import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import {
  user,
  eye,
  bankTransfer,
  dashboard,
  topAgents,
  agentList,
  accounts,
  pinpad,
  pos,
} from "@/modules";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  plugins: [
    createPersistedState({
      key: "readycash-report",
    }),
  ],
  mutations: {},
  actions: {},
  modules: {
    user,
    eye,
    bankTransfer,
    dashboard,
    topAgents,
    agentList,
    accounts,
    pinpad,
    pos,
  },
});
